import React, { useEffect, useState } from 'react'
import { Checkbox } from '@mui/material'
import { formatMoney } from "../../../../utils/amount"
import UpdateCreditReportFields from "../../../../containers/Contacts/add-contact/CreditSelect/UpdateCreditReportFields"
import {
  deleteDebtByDebtId,
  getCreditReportsTypes,
} from "../../../../features/creditReports/creditReports"
import { useMyContextLoading } from "../../../LoadingContextProvider/LoadingContextProvider"
import { useDispatch } from "react-redux"
import { LuPencil, LuTrash2 } from "react-icons/lu"
import ConfirmModal from "../../../ConfirmModal/ConfirmModal"
import { TABLE_HEAD_ROW } from "../../../Table/tableCardClass"

const CustomFirstStepTable = ({
  data,
  setData,
  setSelectedRows,
  selectedRows,
  setTriggerFetchDebts,
  debtsToDelete,
  setDebtsToDelete,
  isUpdate,
}) => {
  const { triggerLoading } = useMyContextLoading()
  const dispatch = useDispatch()

  const titles = ['Creditor', 'Account #', 'Debt Type', 'Current Amount', 'Action']
  const [openUpdate, setOpenUpdate] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [creditLine, setCreditLine] = useState({})
  const [creditReportTypes, setCreditReportTypes] = useState([])
  const [creditProfileToDelete, setCreditProfileToDelete] = useState('')

  const handleCheckboxChange = (event, rowData) => {
    const checked = event.target.checked
    if (checked) {
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, rowData])
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((row) => row._id !== rowData._id)
      )
    }
  }

  const softDeleteDebts = ({ debtId, debt }) => {
    if (debt?.isDebt) {
      setData(data?.filter(debt => debt?._id !== debtId))
      setSelectedRows(selectedRows?.filter(debt => debt?._id !== debtId))
      setDebtsToDelete([...debtsToDelete, debtId])
    } else {
      setCreditProfileToDelete(debtId)
      setOpenDeleteModal(true)
    }
  }

  const removeFunc = async () => {
    triggerLoading(true)
    try {
      await dispatch(deleteDebtByDebtId({ debtId: creditProfileToDelete }))
      setData(data?.filter(debt => debt?._id !== creditProfileToDelete))
    } catch (e) {
      console.log(e)
    }
    triggerLoading(false)
  }

  const handleMasterCheckboxChange = (event) => {
    const checked = event.target.checked
    if (checked) {
      setSelectedRows(data)
    } else {
      setSelectedRows([])
    }
  }

  const getDebtTypes = async () => {
    triggerLoading(true)
    try {
      const responseTypes = await dispatch(getCreditReportsTypes())
      const types = responseTypes?.payload?.data
      if (types) {
        const formattedData = types?.map(item => ({
          value: item._id,
          label: item.description
        }))
        setCreditReportTypes(formattedData)
      }
    } catch (e) {
      console.log(e)
    }
    triggerLoading(false)
  }


  useEffect(() => {
    return () => {
      getDebtTypes()
    }
  }, [isUpdate])


  return (
    <div className="overflow-x-auto rounded-xl border border-divider">
      <table className="text-md text-left w-full text-text-primary min-w-full">
        <thead>
          <tr className={TABLE_HEAD_ROW}>
            <th className="px-4 py-3">
              <Checkbox
                checked={selectedRows?.length === data.length}
                indeterminate={
                  selectedRows?.length > 0 && selectedRows?.length < data?.length
                }
                onChange={handleMasterCheckboxChange}
              />
            </th>
            {titles.map((el, i) => (
              <th
                key={i}
                className={`px-4 py-3 text-[12px] uppercase font-semibold text-text-secondary tracking-wide whitespace-nowrap ${el === 'Current Amount' ? 'text-right' : 'text-left'} ${el === 'Action' ? 'text-center' : ''}`}
              >
                {el}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-divider">
          {
            data.map((element, i) => {
              const debtType = typeof element?.accountType === 'string' ?
                creditReportTypes?.find(type => type?.value === element?.accountType)?.label :
                element?.accountType?.description
              return (
                <tr key={i} className="hover:bg-black/[0.04] dark:hover:bg-white/[0.04] transition-colors">
                  <td className="px-4 py-3 align-middle w-[50px]">
                    <Checkbox
                      checked={selectedRows?.some((row) => row._id === element._id)}
                      onChange={(event) => handleCheckboxChange(event, element)}
                    />
                  </td>
                  <td className="px-4 py-3 align-middle">
                    <div
                      className="overflow-hidden overflow-ellipsis whitespace-nowrap max-w-[120px]"
                      title={element.bankAccount || element.creditorName}
                    >
                      {element.bankAccount || element.creditorName}
                    </div>
                  </td>
                  <td className="px-4 py-3 align-middle">
                    <div
                      className="overflow-hidden overflow-ellipsis whitespace-nowrap max-w-[168px]"
                      title={element.accountNumber}
                    >
                      {element.accountNumber}
                    </div>
                  </td>
                  <td className="px-4 py-3 align-middle">
                    <div
                      className="overflow-hidden overflow-ellipsis whitespace-nowrap max-w-[168px]"
                      title={debtType?.description}
                    >
                      {debtType}
                    </div>
                  </td>
                  <td className="px-4 py-3 align-middle text-right">
                    <div title={formatMoney(element?.balanceAmount)}>
                      {formatMoney(element?.balanceAmount)}
                    </div>
                  </td>
                  <td className="px-4 py-3 align-middle">
                    <div className="flex flex-row justify-center gap-4">
                      <button
                        type="button"
                        onClick={() => {
                          setCreditLine(element)
                          setOpenUpdate(true)
                        }} className="cursor-pointer text-text-secondary hover:text-primary-main">
                        <LuPencil size={20} />
                      </button>

                      <button
                        type="button"
                        className="cursor-pointer text-text-secondary hover:text-error-main"
                        onClick={() => softDeleteDebts({ debtId: element?._id, debt: element })}>
                        <LuTrash2 size={20} />
                      </button>
                    </div>
                  </td>
                </tr>
              )
            }
            )
          }
        </tbody>
      </table>
      <UpdateCreditReportFields open={openUpdate} setOpen={setOpenUpdate} creditLine={creditLine}
        setTriggerFetchDebts={setTriggerFetchDebts} />
      {
        <ConfirmModal
          leftTopIcon={<LuTrash2 size={20} className="text-error-main" />}
          title="Are you sure to delete the credit profile?"
          modalButtonTitle={"Delete"}
          classes=""
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          functionButton={removeFunc}
        >
          You will not be able to restore it later
        </ConfirmModal>
      }
    </div>
  )
}

export default CustomFirstStepTable
